import { render, staticRenderFns } from "./ModalFormRight.vue?vue&type=template&id=1a09051f&scoped=true&"
import script from "./ModalFormRight.vue?vue&type=script&lang=js&"
export * from "./ModalFormRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a09051f",
  null
  
)

export default component.exports